import angular from 'angular';
import '../../shared.module';
import template from './file-input.component.html';
import './file-input.component.scss';

class FileInputController {
  constructor($element, $scope, UploadService) {
    this.$element = $element;
    this.$scope = $scope;
    this.UploadService = UploadService;
    this.errors = [];
    this.dragging = false;
  }

  $postLink() {
    this.input = this.$element[0].querySelector('input[type="file"]');
    this.input.multiple = Boolean(this.multiple);
    this.input.addEventListener('change', (event) => {
      const files = Array.from(event.target.files || []);
      this.$scope.$applyAsync(() => this.select(files));
    });
  }

  get unavailable() {
    return Boolean(this.disabled || this.busy);
  }

  open() {
    if (this.unavailable || !this.input) return;
    this.input.value = '';
    this.input.click();
  }

  keyOpen(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.open();
  }

  dragOver(event) {
    event.preventDefault();
    if (!this.unavailable) this.dragging = true;
  }

  dragLeave() {
    this.dragging = false;
  }

  drop(event) {
    event.preventDefault();
    this.dragging = false;
    if (this.unavailable) return;
    const files = Array.from((event.dataTransfer && event.dataTransfer.files) || []);
    this.select(this.multiple ? files : files.slice(0, 1));
  }

  select(files) {
    if (!files.length) return;
    this.errors = [];
    files.forEach((file) => {
      const failure = this.UploadService.validate(file, {
        maxBytes: this.maxBytes,
        accept: this.accept
      });
      if (failure) {
        this.errors.push(files.length > 1 ? `${file.name}: ${failure.message}` : failure.message);
      } else if (this.onSelect) {
        this.onSelect({ file });
      }
    });
  }
}

FileInputController.$inject = ['$element', '$scope', 'UploadService'];

angular.module('app.shared').component('cpFileInput', {
  bindings: {
    accept: '@',
    maxBytes: '<',
    label: '@',
    hint: '@',
    busy: '<',
    disabled: '<',
    multiple: '<',
    dropzone: '<',
    onSelect: '&'
  },
  controller: FileInputController,
  controllerAs: 'vm',
  template
});
